import moment from "moment";
import React from "react";

import { getDayOfWeek } from "../../helpingFunctions/utilities";
import WindowWidth from "../../hooks/WindowWidth";
import DayButtonLogic from "./DayButtonLogic";

import styles from "./day_button.module.css";

const DayButton = ({
  date,
  timeSelected,
  handleClick,
  isSelected,
  beforeSelected,
  length,
  view,
}) => {
  const { width } = WindowWidth();
  const { widthStyle, isPreparing } = DayButtonLogic(view, length);

  const isInMidRange = width > 700 && length <= 5;
  const isInBigRange = width > 1324;
  const isInFullDisplayRange =
    isInMidRange || isInBigRange;

  return (
    <>
      {isPreparing ? (
        <></>
      ) : (
        <div
          className={`${styles.dayBtn} ${isSelected ? styles.focused : ""} `}
          onClick={handleClick}
          style={{
            width: widthStyle.width,
            height: isSelected ? "75px" : null,
          }}
        >
          <div className={styles.day}>
            <span
              className={`${styles.dayWrapper} ${styles.dayWrapper_desktop}`}
            >
              {isInFullDisplayRange
                ? getDayOfWeek(date)
                : moment(date).format("ddd")}
            </span>
            <span
              className={styles.timeDisplayed}
              style={{
                fontWeight: timeSelected === "not selected" ? "100" : "bold",
                color: "var(--color-info)",
              }}
            >
              {timeSelected}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default DayButton;
